import React from 'react';
import { CurrentRefinements } from 'react-instantsearch-dom';
import { useIntl } from 'react-intl';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import uniqBy from 'lodash/uniqBy';
import capitalize from 'lodash/capitalize';

import filterMessages from 'Components/Search/FilterMessages';

export default function CurrentRefinementsWrapper() {
  const { formatMessage } = useIntl();

  // We only display the current refinement items. The field name is hidden by CSS

  return (
    <CurrentRefinements
      transformItems={
        rootItems => uniqBy(rootItems, item => item.attribute).map((i) => {
          let label;
          let items = i.items;
          if (!isEmpty(items)) {
            items = items.map((item) => {
              label = get(item, 'label', '').toLowerCase();

              if (filterMessages[label]) {
                label = formatMessage(filterMessages[label]);
              }

              label = label === label.toUpperCase() ? label : capitalize(label);

              return { ...item, label };
            });
          }

          if (i.attribute.startsWith('price.')) {
            // Hide min price for price sort auto filter
            if (i.label && i.label.includes('0.01 <=')) {
              return false;
            }

            // Set item or price filter
            items = [{
              label: formatMessage(filterMessages.price_label,
                { filteredPrice: i.currentRefinement },
              ),
              value: i.value, // Need this to make the clear button work
            }];
          }

          // Set item for on_sale toggle
          if (i.currentRefinement === true) {
            items = [{
              label: filterMessages[i.attribute] ? formatMessage(filterMessages[label]) : i.label,
              value: i.value, // Need this to make the clear button work
            }];
          }

          return {
            ...i,
            items,
          };
        }).filter(i => i)
      }
    />
  );
}
